import React, { ReactNode } from "react";
import styled from "styles/styled_components";

const StyledTabButton = styled.button`
  border: none;
  border-left: ${({ theme }) => theme.lightBorder};
  color: ${({ theme }) => theme.colors.brandGray30};
  cursor: pointer;
  flex-basis: 0;
  flex-grow: 1;
  font-size: ${({ theme }) => theme.text.size.base};
  line-height: inherit;
  padding: ${({ theme }) => theme.spacing.small} 0;
  ${props =>
    props["aria-selected"] &&
    `color: ${props.theme.colors.brandBlue50};
    background-color: ${props.theme.colors.brandBlue10};`}
`;

interface ITabButton {
  children: ReactNode;
  id: string;
}

interface ITabButtonProps extends ITabButton {
  selected: boolean;
  onClick: () => void;
}

export default function TabButton({
  children,
  id,
  selected,
  onClick,
}: ITabButtonProps) {
  return (
    <StyledTabButton
      aria-selected={selected}
      aria-controls={`${id}-tabpanel`}
      id={`${id}-tab`}
      onClick={onClick}
      role="tab"
      tabIndex={selected ? 0 : -1}>
      {children}
    </StyledTabButton>
  );
}

export { ITabButton, ITabButtonProps };
